<template>
  <v-container>
    <div class="content">
      <cards-grid
        v-if="showCTModal"
        :chosenMark="chosenMark"
        :chosenModel="chosenModel"
        :items="chosenMark ? carsModels : carMarksFiltred"
        :showAllMarks="showAllMarks"
        @chooseItem="chooseItem($event)"
        @hide="showCTModal = false"
        @changeAllMarks="showAllMarks = $event"
        @clearMark="clearMark"
      />
      <modal name="clientDetailsModal" width="100%" height="100%">
        <div class="p-4" style="background-color: #C9C9C7; height: auto; overflow-y: auto;">
          <h5 class="modal-title p-4 d-inline-block">Заполните недостающие данные о клиенте:</h5>
          <div class="col-6 mx-auto">
            <div class="form-row">
              <div class="col">
                <label for="name">Имя</label>
                <input id="name" type="text"
                       @focus="showError.name = false"
                       class="form-control input input--middle" :class="{
                  'error': showError.name
                }" placeholder="Имя" v-model="clientDetailsModal.name" required>
              </div>
              <div class="col">
                <label for="surname">Фамилия</label>
                <input id="surname" type="text" class="form-control input input--middle"
                       @focus="showError.surname = false"
                       :class="{
                'error': showError.surname
                }" placeholder="Фамилия" v-model="clientDetailsModal.surname" required>
              </div>
            </div>
            <div class="form-group">
              <label for="inputAddress">Телефон</label>
              <input
                  id="inputAddress"
                  name="phone"
                  class="form-control input input--middle"
                  @focus="showError.phone = false"
                  :class="{
                    'error': showError.phone
                  }"
                  type="tel"
                  placeholder="Телефон"
                  v-model="clientDetailsModal.phone"
                  v-mask="'+7(###) ###-##-##'" />
            </div>
            <div class="form-row">
              <div class="col">
                <button class="btn btn-outline-success" @click.prevent="hideClientDetailsModal">Отмена</button>
              </div>
              <div class="col">
                <button class="btn btn-success" @click.prevent="submitClientDetails">Сохранить</button>
              </div>
            </div>
          </div>
        </div>
      </modal>
      <div class="identity">
        <div class="container h-100">
          <div class="row">
            <div class="col-md-5 d-flex justify-content-end">
              <div class="d-flex flex-column max-350">
                <h1 class="mb-3">Карточка клиента</h1>
                <div class="tab-content pt-2 pl-1" id="pills-tabContent">
                  <div class="tab-pane fade" :class="{ 'show active': !chosenLegal }" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
                    <div class="max-310">
                      <div class="form-group mb-3" v-if="client.customer.name">
                        <input data-test-id="clientCardName" class="form-control input input--middle" :class="{ 'error': inputErrors.name }" type="text" placeholder="" :value="fullName">
                      </div>
                      <div class="form-group mb-3" v-if="client.customer.name">
                        <input data-test-id="clientCardPhone" class="form-control input input--middle" :class="{ 'error': inputErrors.phone }" type="text" placeholder="" :value="client.customer.phone">
                      </div>
                      <template v-if="this.client.discount.card_number && this.client.discount.value">
                        <div class="mb-1"><span class="font-size-14 font-weight-600">Бонусная карта</span></div>
                        <div class="mb-3"><span class="font-size-20">{{ this.client.discount.card_number }}</span></div>
                        <div class="mb-3">
                          <div class="discounts">
                            <div class="discounts-current pl-3 mb-2"><span class="font-size-20 font-weight-600 mr-1">{{ Math.trunc((this.client.discount.value + this.client.additional_discount.value) * 100) }}%</span><span class="font-size-18">текущая скидка</span></div>
                            <template v-if="this.client.loyaltyEnabled">
                              <div class="discounts-needed pl-3 mb-2"><span class="font-size-12">Осталось приобрести на {{ (Math.floor(this.client.spent/this.client.thresholdOfDiscount) + 1) * this.client.thresholdOfDiscount - this.client.spent }} ₽</span>
                                <div class="discounts-will d-flex flex-column align-items-center">
                                  <div class="font-size-10">будет</div>
                                  <div class="font-size-18">{{ Math.trunc(((this.client.discount.value + this.client.additional_discount.value) * 100 + 1)) }}%</div>
                                </div>
                              </div>
                              <div class="discounts-all pl-3 mb-2"><span class="font-size-12 mr-1">{{ this.client.fullSpent }}₽</span><span class="font-size-12">— покупки за </span><a class="link" href="#"><span class="font-size-12">всю историю</span></a></div>
                            </template>
                          </div>
                        </div>
                        <div class="mb-3">
                          <div class="form-group d-flex">
                            <v-item-group
                                v-model="selectedPlate"
                                active-class="active"
                            >
                              <v-container class="pl-0 pt-0 mt-0">
                                <v-item
                                    v-for="(car,i) in clientCars"
                                    :key="i"
                                    class="mb-3"
                                    :data-test-id="`clientCars-${car.mark}-${car.model}`"
                                >
                                  <span>
                                    <label class="btn btn-numbers m-1" @click="loadCarDetails([car,i])">
                                      <div class="btn-numbers__wrapper d-flex flex-column">
                                        <div class="plate-number font-size-24 mr-1">{{car.pivot.plate_number}}</div>
                                        <div class="plate-car-model d-flex">
                                          <v-img v-if="car.image" :src="'/'+car.image" height="19" width="19" max-width="19" style="margin-right:2px;"></v-img>
                                          <div style="max-width:132px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">
                                            {{ car.mark }} {{ car.model }}
                                          </div>
                                        </div>
                                      </div>
                                    </label>
                                  </span>
                                </v-item>
                              </v-container>
                            </v-item-group>
                          </div>
                        </div>
                      </template>
                      <template v-else>
                        <div class="col d-flex justify-content-center align-items-center">
                          <router-link to="/newclient" tag="button" class="btn-success btn">Оформить карту</router-link>
                        </div>
                      </template>
                    </div>
                  </div>
                  <div class="tab-pane fade" :class="{ 'show active': chosenLegal }" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab">
                    <div class="form-group mb-3">
                      <select class="browser-default custom-select" name="select-company" v-model="chosenLegal" disabled>
                        <option v-for="(legal, index) in legalClients" :key="'legal-' + index" :value="legal">{{legal.name}}</option>
                      </select>
                    </div>
                    <div class="form-group d-flex align-items-center" :class="{ 'error-border' : inputErrors.selectedPlate && clientCars.length === 0}">
                      <v-form
                          v-model="plateValid"
                          ref="formPlate"
                          class="d-flex w-100"
                      >
                        <v-text-field
                          v-async-validate:debounce="500"
                          v-model="plate"
                          ref="formInputPlate"
                          :async-rules="$_rulesAs.plate"
                          placeholder="Номер авто"
                          maxlength="10"
                          solo
                          :append-icon="plateValid && plate.length > 7 ? 'mdi-checkbox-marked-circle-outline' : ''"
                        />
                        <v-btn
                          class="btn-custom ml-2 w-auto"
                          :disabled="checkplateinput"
                          :loading="carAdding"
                          color="#e8ffcf"
                          style="height: 48px"
                          @click="addClientCar()"
                        >
                          Добавить
                        </v-btn>
                      </v-form>
                    </div>
                    <div class="form-group d-flex" :class="{ 'error-border' : inputErrors.selectedPlate}">
                      <v-item-group
                          v-model="selectedPlate"
                          active-class="active"
                          v-if="clientCarsFilter && clientCarsFilter.length > 0"
                      >
                        <v-container class="pl-0 pt-0 mt-0 plates-placeholder">
                          <v-row>
                            <v-col
                                cols="4"
                                v-for="(car,i) in clientCarsFilter"
                                :key="'newcar-' + i"
                            >
                              <v-item
                                  class="mb-3"
                                  v-slot="{ active, toggle }"
                              >
                                <v-card :data-test-id="`companyCarModal-${car.pivot.plate_number}`" class="btn btn-numbers m-1" @click="[loadCarDetails([car,i]), toggle]">
                                  <div class="btn-numbers__wrapper d-flex flex-column">
                                    <div class="plate-number font-size-24 mr-1">{{car.pivot.plate_number}}</div>
                                    <div class="plate-car-model d-flex">
                                      <v-img v-if="car.image" :src="'/'+car.image" height="19" width="19" max-width="19" style="margin-right:2px;"></v-img>
                                      <div style="max-width:132px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">
                                        {{ car.mark }} {{ car.model }}
                                      </div>
                                    </div>
                                  </div>
                                </v-card>
                              </v-item>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-item-group>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 offset-1 d-flex flex-column justify-content-between">
              <v-row v-if="availableDirections && availableDirections.length > 1">
                <v-col cols="12">
                  <v-btn-toggle
                      v-model="choosenDir"
                      dense
                      mandatory
                  >
                    <template v-for="dir in availableDirections">
                      <v-btn :key="dir.serviceName" :value="dir.serviceName">
                        {{ dir.name }}
                      </v-btn>
                    </template>
                  </v-btn-toggle>
                </v-col>
              </v-row>
              <div class="row">
                <div class="col">
                  <div class="auto-options max-371 d-flex flex-column">
                    <div class="font-size-16 font-weight-600 mb-2">Авто</div>
                    <div
                        class="form-group mb-3"
                        :class="{ 'error-border' : inputErrors.carMark}"
                        style="position: relative"
                    >
                      <input
                          v-model="filter"
                          class="form-control input input--middle w100"
                          type="text"
                          ref="filter"
                          placeholder="Модель или марка"
                          @click="show"
                          @input="check"
                          data-test-id="inputModelAndMark"
                      >
                      <v-btn
                          v-show="filter.length > 0"
                          icon
                          style="position: absolute; top: 10px; right: 0px"
                          @click="clearMark()"
                      >
                        <v-icon> mdi-close </v-icon>
                      </v-btn>
                    </div>
                    <div class="form-group" :class="{ 'error-border' : inputErrors.carType}">
                      <div class="radio-toolbar d-flex justify-content-center align-center">
                        <template v-for="(type,i) in filtrCarTypes" >
                          <span :key="i">
                            <input type="radio" :id="type.slug" name="radioCarType" :value="i+1" v-model="carType">
                            <label :for="type.slug" :data-test-id="type.slug">
                              <div class="btn btn-options__models__icon">
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on }">
                                    <img
                                        :src="'/images/icons/'+ (i+1) + '.png'"
                                        :alt="type.name"
                                        style="max-width: 60px"
                                        v-on="on"
                                    >
                                  </template>
                                  <span>{{ type.name }}</span>
                                </v-tooltip>
                              </div>
                            </label>
                          </span>
                        </template>
  <!--                      <input type="radio" id="radioSedan" name="radioCarType" value="1" v-model="carType">-->
  <!--                      <label for="radioSedan" data-test-id="radioSedan">-->
  <!--                        <div class="btn btn-options__models__icon">-->
  <!--                          <img :src="require('@/assets/images/icons/sedan.png')" alt="седан">-->
  <!--                        </div>-->
  <!--                      </label>-->

  <!--                      <input type="radio" id="radioMinivan" name="radioCarType" value="3" v-model="carType">-->
  <!--                      <label for="radioMinivan" data-test-id="radioMinivan">-->
  <!--                        <div class="btn btn-options__models__icon">-->
  <!--                          <img :src="require('@/assets/images/icons/gazel.png')" alt="минивэн">-->
  <!--                        </div>-->
  <!--                      </label>-->
                      </div>
                    </div>
                    <div
                        v-if="showWheels"
                        class="form-group d-flex justify-content-around"
                        :class="{ 'error-border' : inputErrors.diskType}"
                    >
                      <div class="radio-toolbar d-flex justify-content-between">
                        <input type="radio" id="radioAlloy" name="radioDiskType" value="alloy" v-model="diskType">
                        <label data-test-id="radioDiskTypeAlloy" for="radioAlloy">
                          <div class="btn btn-options__models__icon">
                            <img :src="require('@/assets/images/icons/alloy.png')" alt="литой">
                          </div>
                        </label>

                        <input type="radio" id="radioShtamp" name="radioDiskType" value="shtamp" v-model="diskType">
                        <label for="radioShtamp" data-test-id="radioDiskTypeStamp">
                          <div class="btn btn-options__models__icon">
                            <img :src="require('@/assets/images/icons/shtamp.png')" alt="штампованный">
                          </div>
                        </label>
                      </div>
                    </div>
                    <div
                        v-if="showWheels"
                        class="form-group d-flex justify-content-center"
                    >
                      <div class="radio-toolbar d-flex flex-wrap justify-content-between">
                        <input
                            v-model="frameVehicle"
                            type="checkbox"
                            id="radioFrameVehicle"
                            name="radioFrameVehicle"
                            value="frameVehicle"
                        >
                        <label for="radioFrameVehicle">
                          <div class="btn btn-options__models__icon runflat">
                            <span class="font-size-16 font-italic">
                              Рамный автомобиль
                            </span>
                            <br/>
                            <span class="font-size-10 font-italic border-top pt-1">
                              или профиль от 70 и выше
                            </span>
                          </div>
                        </label>
                      </div>
                    </div>
                    <div class="form-group mb-0" :class="{ 'error-border': inputErrors.diskSize }" v-if="showWheels">
                      <div class="radio-toolbar d-flex flex-wrap justify-content-between">
                        <template v-for="(item) in configDisks">
                          <input :key="`input-${item.value}`" type="radio" :id="item.value" name="radioTyreSize" :value="item.value" v-model="diskSize">
                          <label :key="`label${item.value}`" :for="item.value" :data-test-id="`radioDiskSize${item.value}`">
                            <div class="btn btn-options__models__icon">
                              <span class="font-size-24">{{ item.text }}</span>
                            </div>
                          </label>
                        </template>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 d-flex justify-content-between">
              <v-btn
                  x-large
                  color="yellow"
                  @click="$router.go(-1)"
              >
                назад
              </v-btn>
              <div class="col d-flex justify-content-end align-items-end" @mouseover="checkInputs">
                <v-btn
                    :disabled="disableNext"
                    to="/order/chooseservices"
                    x-large
                    color="#e8ffcf"
                    @click="$store.commit('newOrder', true)"
                >
                  {{ this.choosenDir === 'additional' && (!this.carType || !this.chosenMark) ? 'Пропустить' : 'Продолжить' }}
                </v-btn>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </v-container>
</template>
<script>
import {mapGetters} from 'vuex'
import rules from "@/components/order/rules";
const configDisks = [
  {
    value: 'R12',
    text: 'R12'
  },
  {
    value: 'R13',
    text: 'R13'
  },
  {
    value: 'R14',
    text: 'R14'
  },
  {
    value: 'R15',
    text: 'R15'
  },
  {
    value: 'R16',
    text: 'R16'
  },
  {
    value: 'R17',
    text: 'R17'
  },
  {
    value: 'R18',
    text: 'R18'
  },
  {
    value: 'R19',
    text: 'R19'
  },
  {
    value: 'R20',
    text: 'R20'
  },
  {
    value: 'R21',
    text: 'R21'
  },
  {
    value: 'R22',
    text: 'R22'
  },
  {
    value: 'R23',
    text: 'R23'
  },
  {
    value: 'R24',
    text: 'R24'
  }
]

export default {
  name: 'client_card',
  data() {
    return {
      configDisks,
      plateValid: false,
      carAdding: false,
      showCTModal: false,
      showAllMarks: false,
      filter: '',
      showModal: false,
      plate: '',
      selectedPlate: null,
      inputErrors: {
        carMark: false,
        selectedPlate: false,
        carType: false,
        diskType: false,
        diskSize: false,
        name: false,
        phone: false
      },
      chosenPlate: false,
      clientDetailsModal: {
        name: '',
        surname: '',
        phone: ''
      },
      showError: {
        name: false,
        surname: false,
        phone: false,
      }
    }
  },
  components: {
    cardsGrid: () => import("./carsModelsMarks.vue"),
  },
  created() {
    this.$_rulesAs = {
      plate: [rules.plateNumber({ required: true })],
    };
    if(this.chosenMark && this.chosenModel) {
      this.filter = this.chosenMark + ' ' + this.chosenModel
    }else if(this.chosenMark) {
      this.filter = this.chosenMark + ' '
    }
    if(this.client && this.client.id) {
      this.$store.dispatch('fetchClient', { 'searchString': this.client.id, 'type': 'byId' })
    }
    this.$store.commit('loadClientFromLegal')
    this.$store.dispatch('fetchCarTypes')
    this.$store.dispatch('fetchCarSTypesByService')
  },
  //fetchCarTypes
  async mounted() {
    this.$store.dispatch("login/getWorkshop");
    this.$store.dispatch("fetchCarMarks");
    this.$store.dispatch("fetchClientCars");
  },
  computed: {
    ...mapGetters([
      "legalClients",
      "carMarks",
      "carTypes",
      "carTypesByService",
      "carTypeArr",
      "carMarksModels",
      "carModels",
      "clientCars",
      "clientType",
      "canEditClientCard",
    ]),
    choosenDir: {
      get () {
        return this.$store.getters['login/chosenDirection']
      },
      set (value) {
        this.$store.commit('login/setChosenDirection', value)
      }
    },
    filtrCarTypes () {
      if (this.carTypes && this.carTypesByService) {
        const dirSlug = this.choosenDirSlug !== 'wash' ? 'tyre' : this.choosenDirSlug
        let selectedTypes = this.carTypesByService.filter(carType => carType.service.slug === dirSlug)
        // if (!selectedTypes) selectedTypes = this.carTypes[0]
        return selectedTypes
      } else {
        return []
      }
    },
    choosenDirSlug () {
      return this.$store.getters['login/chosenDirectionSlug']
      // if (this.availableDirections && this.availableDirections.length > 1) {
      //   const finded = this.availableDirections.find((dir) => {
      //     return dir.serviceName === this.choosenDir
      //   })
      //   return finded ? finded.slug : ''
      // } else {
      //   return null
      // }
    },
    disableNext () {
      if (this.showWheels) {
        return !this.diskSize || !this.diskType || !this.carType || !this.checkChosenPlate || !this.chosenMark
      } else if (this.choosenDir === 'additional') {
        return false
      } else {
        return !this.carType || !this.checkChosenPlate || !this.chosenMark
      }
    },
    workshopInfo () {
      return this.$store.state.login.workshop
    },
    showWheels () {
      return this.choosenDir === 'tirefitting'
    },
    availableDirections () {
      return this.$store.state.login.availableDirections
    },
    checkplateinput() {
      if (
        this.plateValid &&
        this.plate.length > 7 &&
        this.chosenMark &&
        this.chosenModel
      ) {
        return false;
      }
      return true
    },
    client: {
      get () {
        return this.$store.getters.client
      },
      set (value) {
        this.$store.commit('updateClient', value)
      }
    },
    allSelected () {
      const val = {
        valid: null,
        data: {
          diskSize: this.diskSize,
          diskType: this.diskType,
          carType: this.carType,
          checkChosenPlate: this.checkChosenPlate,
          chosenMark: this.chosenMark,
        }
      }
      if (this.showWheels) {
        val.valid = !(!this.chosenMark || !this.chosenMark || !this.diskSize || !this.diskType || !this.carType || !this.checkChosenPlate || !(this.client.customer.phone||this.clientType == 'wodiscount'))
      } else {
        val.valid = !(!this.chosenMark || !this.chosenMark || !this.carType || !this.checkChosenPlate || !(this.client.customer.phone||this.clientType == 'wodiscount'))
      }
      return val
    },
    carMarksFiltred () {
      let carMarks = []
      let carMarksModel = []
      if (this.filter.length > 0 && this.carMarks && this.carMarks.length > 0) {
        let filter = this.filter
        filter = filter.replace(/ +/g, ' ').trim()
        filter = filter.split(' ')
        if (filter[0].length > 0) {
          if (!this.chosenMark) {
            this.carMarks.forEach((x)=>{
              let change = this.changeLetters(filter[0])
              let changeEtR = this.changeLettersEtR(filter[0])
              // console.log('model find', x.model && ~x.model.toLowerCase().indexOf(filter[0].toLowerCase()))
              if ( ~x.name.toLowerCase().indexOf(change.toLowerCase()) ||
                  (x.nameRus && ~x.nameRus.toLowerCase().indexOf(filter[0].toLowerCase())) ||
                  (x.nameRus && ~x.nameRus.toLowerCase().indexOf(changeEtR.toLowerCase()))
                  // (x.model && ~x.model.toLowerCase().indexOf(filter[0].toLowerCase()))
              ) {
                let noOne = true
                carMarks.forEach(z=>{
                  if (z.name === x.name) {
                    noOne = false
                  }
                })
                if (noOne) carMarks.push(x)
              }
            })
          } else {
            this.carMarksModels.forEach((x)=>{
              if (x.name && ~x.name.toLowerCase().indexOf(filter[0].toLowerCase())) {
                const toSave = JSON.parse(JSON.stringify(x))
                toSave.carMarkModel = toSave.mark.name + ' | ' + toSave.name
                carMarks.push(toSave)
                carMarksModel.push(toSave)
              }
            })
          }
        }
      }  else if (this.carMarks && this.carMarks.length > 0) {
        this.carMarks.forEach((x)=>{
          if (x.popular || this.showAllMarks) {
            carMarks.push(x)
          }
        })
      } else {
        carMarks = this.carMarks
      }
      if (carMarksModel.length > 0) {
        return [...carMarks, ...carMarksModel]
      }
      return carMarks
    },
    carsModels() {
      return this.showAllMarks ? this.carModels : this.carModelsFiltred
    },
    carModelsFiltred () {
      let carModels = []
      if(this.chosenMark && this.filter.length > 2 && this.carModels.length > 0){
        carModels = this.carModels
        let filter = this.filter
        filter = filter.replace(this.chosenMark, '')
        filter = filter.replace(' ', '').trim()
        if (this.carModels.length > 0 && filter ) {
          carModels = []
          this.carModels.forEach((x)=>{
            let change = this.changeLetters(filter)
            if( x.name.toLowerCase().indexOf(change.toLowerCase()) > -1 || (x.model_transliteration && x.model_transliteration.toLowerCase().indexOf(filter.toLowerCase()) > -1)) {
              carModels.push(x)
            }
          })
        } else {
          carModels = []
          this.carModels.forEach((x)=>{
            if(x.popular) {
              carModels.push(x)
            }
          })
          if(carModels.length===0) {
            carModels = this.carModels
          }
        }
      }
      return carModels
    },
    chosenLegal: {
      get () {
        return this.$store.getters.chosenLegal
      },
      set (value) {
        this.$store.commit('updateChosenLegal', value)
      }
    },
    chosenMark: {
      get () {
        return this.$store.getters.chosenMark
      },
      set (value) {
        this.$store.commit('updateChosenMark', value)
      }
    },
    chosenModel: {
      get () {
        return this.$store.getters.chosenModel
      },
      set (value) {
        this.$store.commit('updateChosenModel', value)
      }
    },
    carType: {
      get () {
        return this.$store.getters.carType
      },
      set (value) {
        this.$store.commit('updateCarType', value)
        const typesArray = []
        if(this.carTypeArr && this.carTypeArr.length > 0) {
          const indx = this.carTypeArr.findIndex((ct)=>{
            return ct.service.slug === this.filtrCarTypes[value-1].service.slug
          })
          this.carTypeArr[indx] = this.filtrCarTypes[value-1]
          this.carTypeArr.forEach(i => {
            typesArray.push(i)
          })
        } else {
          typesArray.push(this.filtrCarTypes[value-1])
        }
        this.$store.commit('updateCarTypeArr', typesArray)
      }
    },
    diskType: {
      get () {
        return this.$store.getters.diskType
      },
      set (value) {
        this.$store.commit('updateDiskType', value)
      }
    },
    runflat: {
      get () {
        return this.$store.getters.runflat
      },
      set (value) {
        this.$store.commit('updateRunflat', value)
      }
    },
    frameVehicle: {
      get () {
        return this.$store.getters.frameVehicle
      },
      set (value) {
        this.$store.commit('updateFrameVehicle', value)
      }
    },
    diskSize: {
      get () {
        return this.$store.getters.diskSize
      },
      set (value) {
        this.$store.commit('updateDiskSize', value)
      }
    },
    plateNumber: {
      get () {
        return this.$store.getters.plateNumber
      },
      set (value) {
        this.$store.commit('updatePlateNumber', value)
      }
    },
    fullName () {
      if(this.client.customer.surname) {
        return this.client.customer.name + ' ' + this.client.customer.surname
      }
      return this.client.customer.name
    },

    checkChosenPlate () {
      if (this.chosenLegal && !this.chosenPlate) {
          return false
      }
      return true
    },
    clientCarsFilter () {
      let cars
      if (this.clientCars && this.clientCars.length > 0) {
        cars = this.clientCars
        if (this.plate && this.plate.length > 2 && cars.length > 0) {
          cars = cars.filter(i => ~i.pivot?.plate_number?.toLowerCase().indexOf(this.plate.toLowerCase()))
          if (cars.length === 0) {
            cars = this.clientCars
          } else if (cars[0] && cars[0].pivot?.plate_number?.toLowerCase() === this.plate.toLowerCase()) {
            this.loadCarDetails([cars[0],0])
          }
        }
      } else { cars = null }
      return cars
    }
  },
  watch: {
    choosenDir () {
      console.log('set choosenDir')
      this.checkUpdateCarType()
    },
    allSelected (newVal) {
      // console.log('ss', newVal.valid)
      // console.log('ss', newVal.data)
      if (newVal.valid && !this.canEditClientCard && this.showWheels) this.$router.push('/order/chooseservices')
    },
    clientDetailsModal: {
      handler(){
        while(this.clientDetailsModal.phone.charAt(0) === '8' || this.clientDetailsModal.phone.charAt(0) === '7' )
        {
          return this.clientDetailsModal.phone = this.clientDetailsModal.phone.substr(1);
        }
      },
      deep: true
    }
  },
  methods: {
    checkUpdateCarType () {
      // console.log('carTypeArr', this.carTypeArr)
      // console.log('choosenDirSlug', this.choosenDirSlug)
      // console.log('filtrCarTypes', this.filtrCarTypes)
      if(this.carTypeArr){
        const dirSlug = this.choosenDirSlug !== 'wash' ? 'tyre' : this.choosenDirSlug
        this.carTypeArr.forEach(i => {
          if (i.service.slug == dirSlug) {
            const newCarTypeIndx = this.filtrCarTypes.findIndex(fct => {
              return i.id === fct.id
            })
            console.log(newCarTypeIndx)
            this.carType = newCarTypeIndx + 1
          }
        })
      // if (this.carType) {
      //   const typesArray = []
      //   if(this.carTypeArr && this.carTypeArr.length > 0) {
      //     const indx = this.carTypeArr.findIndex((ct)=>{
      //       return ct.service.slug === this.filtrCarTypes[this.carType-1].service.slug
      //     })
      //     this.carTypeArr[indx] = this.filtrCarTypes[this.carType-1]
      //     this.carTypeArr.forEach(i => {
      //       typesArray.push(i)
      //     })
      //   } else {
      //     typesArray.push(this.filtrCarTypes[this.carType-1])
      //   }
      //   this.$store.commit('updateCarTypeArr', typesArray)
      }
    },
    chooseItem(val) {
      console.log('io', val)
      if (!this.chosenMark) {
        this.chosenMark = val.name
        this.loadModels(val.name, val.id)
      } else if (this.chosenMark) {
        this.setCarType([val.type, val.name])
        this.$store.commit('updateChosenCarId', val.id)
        setTimeout(() => {
          this.showCTModal=false
        }, 100)
      }
    },
    changeLetters(str) {
      let replace = new Array(
          "й","ц","у","к","е","н","г","ш","щ","з","х","ъ",
          "ф","ы","в","а","п","р","о","л","д","ж","э",
          "я","ч","с","м","и","т","ь","б","ю"
      )
      let search = new Array(
          "q","w","e","r","t","y","u","i","o","p","\\[","\\]",
          "a","s","d","f","g","h","j","k","l",";","'",
          "z","x","c","v","b","n","m",",","\\."
      )
      for (let i = 0; i < replace.length; i++) {
        let reg = new RegExp(replace[i], 'mig');
        str = str.replace(reg, function (a) {
          return a && a == a.toLowerCase() ? search[i] : search[i].toUpperCase();
        })
      }
      return str
    },
    changeLettersEtR(str) {
      let search = new Array(
          "й","ц","у","к","е","н","г","ш","щ","з","х","ъ",
          "ф","ы","в","а","п","р","о","л","д","ж","э",
          "я","ч","с","м","и","т","ь","б","ю"
      )
      let replace = new Array(
          "q","w","e","r","t","y","u","i","o","p","\\[","\\]",
          "a","s","d","f","g","h","j","k","l",";","'",
          "z","x","c","v","b","n","m",",","\\."
      )
      for (let i = 0; i < replace.length; i++) {
        let reg = new RegExp(replace[i], 'mig');
        str = str.replace(reg, function (a) {
          return a == a.toLowerCase() ? search[i] : search[i].toUpperCase();
        })
      }
      return str
    },
    resetVlidation () {
    },
    checkFilter () {
      const tempMark = this.chosenMark && this.chosenMark.length > 0 ? this.filter.substr(0,this.chosenMark.length) : false
      const tempModel = this.chosenModel && this.chosenModel.length > 0 ? this.filter.substr(this.chosenMark.length+1,this.chosenModel.length) : false
      if (tempMark && tempMark === this.chosenMark) {
        if (tempModel && tempModel !== this.chosenModel) {
          this.filter = this.chosenMark + ' '
          this.chosenModel = ''
          this.carType = ''
        }
      } else {
        this.clearMark()
      }
      this.$nextTick(() => {
        this.$refs.filter.blur()
      })
    },
    clearMark() {
      this.filter = ''
      this.chosenMark = null
      this.chosenModel = null
    },
    check (e) {
      if (e.inputType!=="deleteContentBackward") {
        if (this.filter.length > 0) {
          let filter = this.filter
          if (this.chosenMark && this.chosenMark.length > 0) {
            filter = filter.replace(this.chosenMark, '')
            filter = filter.replace(' ', '').trim()
            if (filter.length > 1) {
              if (this.carModelsFiltred.length === 1 && this.chosenMark) {
                this.setCarType([this.carModelsFiltred[0].type, this.carModelsFiltred[0].name])
                this.$store.commit('updateChosenCarId', this.carModelsFiltred[0].id)
                this.hide()
                this.$refs.filter.blur()
                setTimeout(() => {
                  this.showCTModal=false
                }, 100)
              } else {
                this.carModels.forEach((x) => {
                  if (x.name.toLowerCase() === filter.toLowerCase()) {
                    if (filter.length === x.name.length) {
                      this.setCarType([x.type, x.name])
                      this.$store.commit('updateChosenCarId', this.carModelsFiltred[0].id)
                      this.hide()
                      this.$refs.filter.blur()
                      setTimeout(() => {
                        this.showCTModal=false
                      }, 100)
                    }
                  }
                })
              }
            }
          } else {
            if (filter && filter.length > 1) {
              this.carMarks.forEach((x) => {
                if (x.name.toLowerCase() === filter.toLowerCase()) {
                  if (this.filter.length === x.name.length) {
                    this.loadModels(x.name, x.id)
                  }
                }
              })
            }
          }
        } else {
          this.chosenMark = null
          this.chosenModel = null
        }
      } else {
        if (this.chosenMark && this.chosenMark.length > 0) {
          let filter = this.filter
          filter = filter.replace(this.chosenMark, '')
          filter = filter.replace(' ', '').trim()
          if(filter.length > 0 && this.filter.trim() !== this.chosenMark) {
            this.chosenModel = null
          } else {
            this.chosenMark = null
          }
        }
      }
    },
    show () {
      this.showCTModal = true
      // this.$modal.show('carModelModal');
      this.$nextTick(() => {
        this.$refs.filter.focus()
      })
    },
    hide () {
      this.checkFilter()
      console.log('hide filtr')
      this.$modal.hide('carModelModal');
    },
    showClientDetailsModal () {
      this.clientDetailsModal.name = this.client.customer.name
      this.clientDetailsModal.surname = this.client.customer.surname
      this.clientDetailsModal.phone = this.client.customer.phone
      this.$modal.show('clientDetailsModal');
    },
    hideClientDetailsModal () {
      this.$modal.hide('clientDetailsModal');
    },
    loadModels(carMark, id) {
      this.$store.commit('updateCarModels', {})
      this.filter = carMark + ' '
      this.chosenMark = carMark
      this.$store.dispatch('fetchCarModels', id)
      this.$nextTick(() => {
        if (this.$refs.filter) {
          this.$refs.filter.focus()
        }
      })
    },
    setCarType([carTypeId, carModel]) {
      this.filter = this.chosenMark + ' ' + carModel
      this.chosenModel = carModel
      const carTypeIndex = this.filtrCarTypes.findIndex(t => carTypeId.some((ct => ct.slug === t.slug)))
      this.$store.commit('updateCarType', carTypeIndex+1)
      this.$store.commit('updateCarTypeArr', carTypeId)
    },
    loadCarDetails([car,index]) {
      this.selectedPlate = index
      this.plateNumber = car.pivot.plate_number
      this.filter = car.mark + ' ' + car.model
      this.chosenMark = car.mark
      this.chosenModel = car.model
      this.carType = car.car_type_id
      this.client.plate = car.pivot.plate_number
      this.client.car_id = car.pivot.id
      this.chosenPlate = car.pivot.plate_number
      if( this.carMarks){
        const mark = this.carMarks.find((x) => {
          return (x.name.toLowerCase() === car.mark.toLowerCase())
        })
        this.$store.dispatch('fetchCarModels', mark.id).then((response) => {
          console.log('car.model',car.model)
          console.log('car.response',response)
          const model = response.find((m) => {
            return m.name.toLowerCase() == car.model.toLowerCase()
          })
          console.log('model', model)
          if (model) this.$store.commit('updateCarTypeArr', model.type)
        })
      }
    },
    addClientCar() {
      this.carAdding = true
      const payload = {
        carMark: this.chosenMark,
        carModel: this.chosenModel,
        plate_number: this.plate,
        userId: this.client.id,
      }
      this.$store.dispatch('addClientCar', payload).then(()=>{
        let carIndex = this.clientCars.findIndex(x => {
          if(x.pivot?.plate_number === this.plate) return true
        })
        this.carAdding = false
        this.plate = ''
        this.loadCarDetails([this.clientCars[carIndex],carIndex])
        this.$nextTick(() => setTimeout(this.$refs.formPlate.resetValidation(), 700))
      })
    },
    resetModel() {
      this.chosenMark = ''
      this.chosenModel = ''
      this.carType = ''
      this.filter = ''
    },
    checkInputs() {
      this.selectedPlate == null ? this.inputErrors.selectedPlate = true : this.inputErrors.selectedPlate = false
      this.chosenMark == '' && this.choosenDir !== 'additional' ? this.inputErrors.carMark = true : this.inputErrors.carMark = false
      this.carType == '' && this.choosenDir !== 'additional' ? this.inputErrors.carType = true : this.inputErrors.carType = false
      this.diskSize == '' ? this.inputErrors.diskSize = true : this.inputErrors.diskSize = false
      this.diskType == '' ? this.inputErrors.diskType = true : this.inputErrors.diskType = false
      this.client.customer.name == null ? this.inputErrors.name = true : this.inputErrors.name = false
      this.client.customer.phone == null ? this.inputErrors.phone = true : this.inputErrors.phone = false
      if(!this.client.customer.phone && this.clientType != 'wodiscount' ) {
        this.showClientDetailsModal()
      }
    },
    submitClientDetails() {
      const {phone, name, surname} = this.clientDetailsModal
      const phoneValid = phone.length === 17;
      const nameValid = name.length >= 1;
      const surnameValid = surname.length >= 1;
      const formValid =  phoneValid && nameValid && surnameValid;

      if (formValid) {
        const payload = {
          name: this.clientDetailsModal.name,
          surname: this.clientDetailsModal.surname,
          phone: this.clientDetailsModal.phone,
          clientId: this.client.id
        }
        this.$store.dispatch('saveOldClientDetails', payload)
        this.hideClientDetailsModal()
      } else {
        this.showError.name = !nameValid
        this.showError.surname = !surnameValid
        this.showError.phone = !phoneValid
      }
    }
  }
}
</script>

<style scoped>
.btn {
  margin: 0.375rem;
  color: inherit;
  text-transform: uppercase;
  word-wrap: break-word;
  white-space: normal;
  cursor: pointer;
  border: 0;
  border-radius: 0.125rem;
  -webkit-box-shadow: 0 2px 5px 0 rgb(0 0 0 / 16%), 0 2px 10px 0 rgb(0 0 0 / 12%);
  box-shadow: 0 2px 5px 0 rgb(0 0 0 / 16%), 0 2px 10px 0 rgb(0 0 0 / 12%);
  -webkit-transition: color 0.15s ease-in-out,background-color 0.15s ease-in-out,border-color 0.15s ease-in-out,-webkit-box-shadow 0.15s ease-in-out;
  transition: color 0.15s ease-in-out,background-color 0.15s ease-in-out,border-color 0.15s ease-in-out,-webkit-box-shadow 0.15s ease-in-out;
  transition: color 0.15s ease-in-out,background-color 0.15s ease-in-out,border-color 0.15s ease-in-out,box-shadow 0.15s ease-in-out;
  transition: color 0.15s ease-in-out,background-color 0.15s ease-in-out,border-color 0.15s ease-in-out,box-shadow 0.15s ease-in-out,-webkit-box-shadow 0.15s ease-in-out;
  padding: 0.84rem 2.14rem;
  font-size: .81rem;
}

.plates-placeholder {
  width: 550px;
  position: absolute;
  left: -150px;
  height: 450px;
  overflow-y: auto;
}
.v--modal-overlay .v--modal-box.v--modal {
  overflow: visible!important;
}
.button-hide{
  display: block;
  width: fit-content;
  border: 1px solid #805b5b;
  border-radius: 9px;
  padding-left: 6px;
  padding-right: 6px;
  margin-left: auto;
  margin-right: 14px;
  font-size: small;
  color: dimgrey;
}
.pointer {
  cursor: pointer;
}
.btn.btn-options__models__icon.runflat{
  width: 250px;
}

.modal-dialog{
  overflow-y: initial !important
}
.modal-body{
  height: 50%;
  overflow-y: auto;
}

.identity {
  height: 100%;
  min-height: 100%;
  padding: 0;
  position: relative;
}

.identity .btn-close {
  position: absolute;
  top: 53px;
  right: 52px;
}
.nav-pills.show .nav-link {
  color: #727272;
}

.nav-pills .nav-link {
  width: 110px;
  height: 37px;
  font-family: "Istok Web Regular";
  font-size: 14px;
  color: #727272;
  border: 1px solid #b8b8b8;
  border-radius: 0;
  text-align: center;
  box-shadow: 0 2px 7px 0 rgba(0, 0, 0, .18), 0 2px 7px 0 rgba(0, 0, 0, .15);
}
.nav-pills .nav-link.active {
  background-color: #fffbcd;
  color: #727272;
  box-shadow: none;
}
.nav-pills .nav-link.order-tabs {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 210px;
  height: 54px;
  font-family: "Istok Web Bold";
  font-size: 20px;
  line-height: 28px;
  color: #000000;
  box-shadow: 3px 4px 10px 0 rgba(0, 0, 0, .5);
}
.nav-pills .nav-link.order-tabs.active {
  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, .5);
}
.nav-pills .nav-link.modal-tabs {
  width: 159px;
}

.input {
  /*font-family: "Istok Web Regular";*/
  background-color: #e9e9e9;
}
.input--small {
  height: 47px;
  font-size: 15px;
  border-radius: 8px;
}
.input--middle {
  height: 56px;
  font-size: 20px;
  border-radius: 15px;
}
.input--hidden {
  opacity: 0;
  position: fixed;
  width: 0;
}
.input.error {
  border-color: #d0021b;
}

.custom-select {
  height: 56px;
  background-color: #e9e9e9;
  font-family: "Istok Web Regular";
  font-size: 20px;
  color: #4a4a4a;
  border-radius: 11px;
}
.custom-select option {
  font-size: 20px;
}

.btn-numbers {
  margin: 0;
  display: flex;
  border-radius: 10px;
  padding: 3px 8px 3px 12px;
  font-family: "Istok Web Regular";
  background-color: #ffffff;
  width: 165px;
  height: 54px;
}
.btn-numbers__wrapper {
  width: 100%;
  display: flex;
  align-items: baseline;
  text-transform: none;
}
.btn-numbers__kod {
  display: flex;
  align-items: flex-start;
  font-size: 22px;
}
.btn-numbers.active {
  background-color: #fffbcd;
  box-shadow: inset 1px 2px 4px 0 rgba(0, 0, 0, .4);
}

.btn-options {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border-radius: 9px;
}
.btn-options.active {
  background-color: #fffbcd;
  box-shadow: inset 1px 2px 4px 0 rgba(0, 0, 0, .4);
}
.btn-options__models,
.btn-options__tires {
  width: 119px;
  height: 45px;
}
.btn-options__tires-size {
  display: inline-block;
  background-color: #ddd;
  padding: 10px 20px;
  font-family: sans-serif, Arial;
  font-size: 16px;
  border: 2px solid #444;
  border-radius: 4px;
}
.btn-options__tires-size span {
  line-height: 1;
  padding-top: 3px;
}
.btn-options__complex-tires-size {
  width: 68px;
  height: 45px;
}
.btn-options__complex-tires-size span {
  font-weight: 400;
  line-height: 18px;
}
.btn-options__w142 {
  width: 142px;
}

.btn-custom {
  margin: 0;
  width: 259px;
  height: 56px;
  font-family: "Istok Web Regular";
  font-size: 20px;
  color: #4a4a4a;
  border: 1px solid #ced4da;
  border-radius: 11px;
  background-color: #e8ffcf;
  text-transform: none;
}
.btn-custom.disabled {
  background: linear-gradient(180deg, #979797 0%, #d0d0d0 100%);
}

.btn-close {
  font-family: "ITC Zapf Dingbats Medium";
  font-size: 26px;
  color: #000000;
  border: none;
  background: transparent;
  padding: 0 8px;
  transition: all .35s ease-in-out;
  z-index: 11;
}

.w100 {
  width: 100%;
}

.discounts {
  background-color: #daffb0;
  padding-top: 14px;
  padding-bottom: 6px;
}
.discounts-needed {
  position: relative;
  background-color: rgba(74, 144, 226, .5);
}
.discounts-will {
  position: absolute;
  background-color: #7ed321;
  border-radius: 100%;
  padding: 4px 7px;
  top: -13px;
  right: 10px;
}
.discounts-current {
  line-height: 1;
}
.discounts-not {
  background-color: #ffc4cb;
}
.discounts-not.discounts-not .discounts-needed {
  background-color: #ffaab4;
}
.discounts-empty {
  position: absolute;
  top: -13px;
  right: 10px;
}
.discounts button.btn {
  height: 33px;
}

.discounts-card {
  width: 483px;
  border-radius: 7px;
  box-shadow: 4px 6px 6px 0 rgba(0, 0, 0, .5);
  padding: 23px 0 24px 0;
}
.discounts-card__wrap {
  padding: 0 20px 23px 20px;
}
.discounts-card__color {
  display: inline-block;
  width: 21px;
  height: 21px;
  border-radius: 50%;
}
.discounts-card__color.red {
  background-color: #d0021b;
}
.discounts-card__color.blue {
  background-color: #4a90e2;
}
.discounts-card__tires-size {
  display: inline-block;
  width: 23px;
  height: 23px;
  background-size: contain;
  background-repeat: no-repeat;
}
.discounts-card__number {
  border: 1px solid #4a4a4a;
  border-radius: 4px;
  padding: 6px 5px 4px 8px;
  line-height: 1;
}
.discounts-card__number-flag {
  display: inline-block;
  width: 14px;
  height: 9px;
  background-size: contain;
  background-repeat: no-repeat;
}
.discounts-card__number-flag.flag-ru {
  /*background-image: */
}
.discounts-card .discounts-needed {
  padding: 6px 10px 6px 20px;
}
.discounts-card .discounts-needed .discounts-empty svg {
  width: 57px;
  height: 57px;
}
.discounts-card__promo {
  padding: 5px 16px 3px 16px;
}

.font-size-10 {
  font-size: 10px !important;
}

.font-size-12 {
  font-size: 12px !important;
}

.font-size-14 {
  font-size: 14px !important;
}

.font-size-18 {
  font-size: 18px !important;
}

.font-size-20 {
  font-size: 20px !important;
}

.font-size-22 {
  font-size: 22px !important;
}

.font-size-24 {
  font-size: 24px !important;
}

.font-size-26 {
  font-size: 26px !important;
}

.font-size-28 {
  font-size: 28px !important;
}

.font-size-30 {
  font-size: 30px !important;
}

.font-weight-600 {
  font-weight: 600 !important;
}

.font-weight-700 {
  font-weight: 700 !important;
}

.font-italic {
  font-style: italic !important;
}

.max-310 {
  max-width: 310px;
}

.max-350 {
  max-width: 350px;
}

.max-371 {
  max-width: 371px;
}

.max-483 {
  max-width: 483px;
}

.spacer {
  flex: 1 0 auto;
}


.radio-toolbar input[type="radio"], input[type="checkbox"] {
  opacity: 0;
  position: fixed;
  width: 0;
}

.radio-toolbar label {
  display: inline-block;
  align-items: center;
  justify-content: center;
  padding: 5px 10px;
  border-radius: 15px;
}

.btn-options__models__icon {
  display: table-cell;
  padding: 10px;
  width: 5vw;
  height: 6vh;
  border-radius: 15px;
  vertical-align: middle;
}

.btn-options__marks__icon {
  display: table-cell;
  padding: 0;
  width: 10vw;
  height: 4vh;
  border-radius: 15px;
  vertical-align: middle;
}

.btn-options__models__icon:hover {
  box-shadow: 0 5px 11px 0 rgba(0,0,0,0.18), 0 4px 15px 0 rgba(0,0,0,0.15);
}
.carmark {
  border-radius: 0;
  background-color: white;
  box-shadow: none;
  border: 1px #acadac solid;
}

.carmark::first-letter {
  font-weight: 800;
}


.radio-toolbar input[type="radio"]:focus + label, input[type="checkbox"]:checked  + label {
  border-radius: 15px;
}

.radio-toolbar input[type="radio"]:checked + label>div, input[type="checkbox"]:checked + label>div {
  background-color: #fffbcd;
  box-shadow: inset 1px 2px 4px 0 rgba(0, 0, 0, .4);
}

.car-models {
  padding: 50px;
}
.car-model {
  margin: 10px;
}

.plate-number {
  height: 28px;
}

.error-border {
  border: solid 1px red;
  border-radius: 15px;
}
</style>
